/**
 * Format error messages from API responses
 * Handles string errors, Pydantic validation errors, and generic objects
 */
export const formatErrorMessage = (error) => {
  // If error is already a string, return it
  if (typeof error === 'string') {
    return error;
  }

  // If error is from axios/fetch response
  if (error.response?.data) {
    const detail = error.response.data.detail;
    return formatDetailError(detail);
  }

  // If error has a detail property directly (from fetch response.json())
  if (error.detail) {
    return formatDetailError(error.detail);
  }

  // If error has a message property
  if (error.message) {
    return error.message;
  }

  // Fallback
  return 'An error occurred';
};

/**
 * Format the detail field from API error responses
 */
const formatDetailError = (detail) => {
  // If detail is a string, return it directly
  if (typeof detail === 'string') {
    return detail;
  }

  // If detail is an array of validation errors (Pydantic)
  if (Array.isArray(detail)) {
    return detail.map(err => {
      // Handle Pydantic validation error format
      if (err.loc && err.msg) {
        const field = Array.isArray(err.loc) ? err.loc.join('.') : err.loc;
        return `${field}: ${err.msg}`;
      }
      // Handle other array item formats
      return err.msg || err.message || JSON.stringify(err);
    }).join(', ');
  }

  // If detail is an object with msg/message
  if (typeof detail === 'object') {
    return detail.msg || detail.message || JSON.stringify(detail);
  }

  // Fallback
  return 'An error occurred';
};
